export default "__VITE_ASSET__7e85d462__"